import { MAX_SUPPLIER_TOKEN_EXPIRATION_DAYS } from 'types';
import z from 'zod';

export const supplierTokenFormValidator = z.object({
  name: z.string().min(1).max(100),
  expiresInDays: z
    .number()
    .int()
    .positive()
    .max(MAX_SUPPLIER_TOKEN_EXPIRATION_DAYS),
});

export type SupplierTokenFormData = z.infer<typeof supplierTokenFormValidator>;
